import { render, staticRenderFns } from "./PinSetting.vue?vue&type=template&id=6e0f6052&"
import script from "./PinSetting.vue?vue&type=script&lang=js&"
export * from "./PinSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports